(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/seo-article-widget/assets/javascripts/seo-article-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/seo-article-widget/assets/javascripts/seo-article-widget.js');
"use strict";


class SeoArticleWidget extends HTMLElement {
  static get observedAttributes() {
    return ['args'];
  }
  get args() {
    return this.getAttribute('args');
  }
  connectedCallback() {
    if (!this.args) {
      return;
    }
    const {
      article
    } = JSON.parse(this.args);
    if (article !== null && article !== void 0 && article.body) {
      const articleElement = document.createElement('article');
      articleElement.setAttribute('class', 'seo-article-widget');
      this.appendChild(articleElement);
      articleElement.innerHTML = article.body;
    }
  }
}
customElements.define('seo-article-widget', SeoArticleWidget);

 })(window);